export const devConfig = {
  AG_GRID_LICENSE_KEY:
    'Using_this_{AG_Grid}_Enterprise_key_{AG-100070}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{AssetMetrix_GmbH}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{Portal_Next}_only_for_{4}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_working_on_{Portal_Next}_need_to_be_licensed___{Portal_Next}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{5_August_2027}____[v3]_[01]_MTgxNzQyMDQwMDAwMA==038603fdd95cd26c8677995f4eaba739',

  // Local backend with nginx reverse proxy (pnpm run proxy:remote, don't forget to check nginx-remote-debug.conf)
  // PORTAL_API_URL: window.location.origin,
  // PORTAL_GATEWAY_API_BASE_URL: window.location.origin,

  // Local backend
  // PORTAL_GATEWAY_API_BASE_URL: 'http://localhost:3000',
  // PORTAL_API_URL: 'http://localhost:9002',

  // AM Dev backend
  PORTAL_GATEWAY_API_BASE_URL: 'https://dev.services-dev.lux.asset-metrix.io',
  PORTAL_API_URL: 'https://portal-api.services-dev.lux.asset-metrix.io',

  // AM Demo backend
  // PORTAL_GATEWAY_API_BASE_URL:
  //   'https://asset-metrix.services-demo.asset-metrix.com',
  // PORTAL_API_URL: 'https://portal-api.services-demo.asset-metrix.com',

  // AM Pre-Prod backend
  // PORTAL_GATEWAY_API_BASE_URL:
  //   'https://asset-metrix.services-preprod.asset-metrix.com',
  // PORTAL_API_URL: 'https://portal-api.services-preprod.asset-metrix.com',

  // AM Prod backend
  // PORTAL_GATEWAY_API_BASE_URL:
  //   'https://asset-metrix.services.asset-metrix.com',
  // PORTAL_API_URL: 'https://portal-api.services.asset-metrix.com',

  // BNP Dev backend
  // PORTAL_GATEWAY_API_BASE_URL:
  //   'https://asset-metrix.bnpparibas-dev.asset-metrix.com',
  // PORTAL_API_URL: 'https://portal-api.bnpparibas-dev.asset-metrix.com',

  // BNP UAT backend
  // PORTAL_GATEWAY_API_BASE_URL:
  //   'https://asset-metrix.bnpparibas-uat.asset-metrix.com',
  // PORTAL_API_URL: 'https://portal-api.bnpparibas-uat.asset-metrix.com',

  // BNP Pre-Prod backend
  // PORTAL_GATEWAY_API_BASE_URL:
  //   'https://asset-metrix.bnpparibas-preprod.asset-metrix.com',
  // PORTAL_API_URL: 'https://portal-api.bnpparibas-preprod.asset-metrix.com',

  // BNP Prod backend
  // PORTAL_GATEWAY_API_BASE_URL:
  //   'https://asset-metrix.bnpparibas.asset-metrix.com',
  // PORTAL_API_URL: 'https://portal-api.bnpparibas.asset-metrix.com',

  // BNP Demo backend
  // PORTAL_GATEWAY_API_BASE_URL:
  //   'https://asset-metrix.bnpparibas-demo.asset-metrix.com',
  // PORTAL_API_URL: 'https://portal-api.bnpparibas-demo.asset-metrix.com',

  // Sentry Configuration
  SENTRY_ENABLED: 'false',
  SENTRY_ENVIRONMENT: 'local',
  SENTRY_MASK_ALL_TEXT: 'false',
  SENTRY_DSN:
    'https://32ff9d22f669b85f7f39c8ebdc0d828e@o4507470733246464.ingest.de.sentry.io/4508295854096464',

  // General Configuration
  RELEASE_VERSION: 'development',
  /** Empty: use default same-origin `/user-management/` from config/index.ts */
  // eslint-disable-next-line unicorn/prefer-https -- local dev server
  USER_MANAGEMENT_APP_URL: 'http://dev.localhost:4029/user-management/',

  /** Empty: use default same-origin `/poco/` from config/index.ts */
  // eslint-disable-next-line unicorn/prefer-https -- local dev server
  POCO_APP_URL: 'http://dev.localhost:4042/poco/',

  ROUTE_BASE_NAME: '/next/',
  // ROUTE_BASE_NAME: '',

  NODE_ENV: 'local',

  DOWNLOAD_DATE_PREFIX_FORMAT: undefined,

  APPLICATION_UUID: '2912e629-aa2e-4ee6-bf69-0d00cce41222',
};
